import { AnalyticsRepository } from '../../domain/repositories/analytics.repository';
import { AnalyticsDashboard } from '../../domain/entities/analytics.entity';

export class GetAnalyticsDashboardUseCase {
  constructor(private readonly analyticsRepository: AnalyticsRepository) {}

  public async execute(startDate?: string, endDate?: string): Promise<AnalyticsDashboard> {
    return await this.analyticsRepository.getDashboard(startDate, endDate);
  }
}
